module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reports":{"name":"Reports","url":"reports"},"deletionReport":"Guest deletion report","forProperty":"for property","title":"Title","tax":"Tax","amount":"Amount","quantity":"Quantity"},"sl":{"reports":{"name":"Poročila","url":"porocila"},"deletionReport":"Poročilo o izbrisu gostov","forProperty":"nastanitve","title":"Naziv","tax":"Taksa","amount":"Znesek","quantity":"Količina"}}')
  delete Component.options._Ctor
}
